import * as React from 'react';

import { mergeStyles } from '@cian/utils';

import { Price } from '../../offer-card/components/price';

import * as priceStyles from '../../offer-card/components/price/index.css';
import * as styles from './TopPrice.css';

/**
 * Блок цены и доп.условий для царь-карточки.
 *
 * По отношению к базовому блоку немного изменилась структура и стили (шрифт стал больше).
 */
export class TopPrice extends Price {
  public render() {
    const offer = this.context.offerHelper;

    if (
      this.context.offer.offerType === 'commercial' ||
      offer.commercial.isCommercialLand()
    ) {
      return null;
    }

    const terms = this.context.offer.dealType === 'rent'
      ? this.getRentPriceTerms(this.props.excludedUtilitiesTermsRegions)
      : this.getSalePriceTerms();

    return (
      <div>
        {terms.map((term: React.ReactNode, index) => {
          if (term) {
            return (
              <div
                key={index}
                {...mergeStyles([
                  index === 0 ? styles['header'] : priceStyles['term'],
                  index === 0 && this.props.priceClassName,
                ])}
              >
                {term}
              </div>
            );
          }

          return null;
        })}
      </div>
    );
  }
}
